import { assertPublicKey } from '@shkola/api';

export { assertPublicKey };

export type AppEnv = 'development' | 'demo' | 'production';

export interface WebEnv {
  supabaseUrl?: string;
  supabaseKey?: string;
  appEnv: AppEnv;
}

export function readEnv(source: Record<string, string | undefined>): WebEnv {
  const appEnv = source.VITE_APP_ENV ?? 'development';
  if (appEnv !== 'development' && appEnv !== 'demo' && appEnv !== 'production') {
    throw new Error(`Unknown VITE_APP_ENV "${appEnv}"`);
  }
  const supabaseKey = source.VITE_SUPABASE_PUBLISHABLE_KEY || undefined;
  if (supabaseKey) assertPublicKey(supabaseKey);
  return {
    appEnv,
    ...(source.VITE_SUPABASE_URL ? { supabaseUrl: source.VITE_SUPABASE_URL } : {}),
    ...(supabaseKey ? { supabaseKey } : {}),
  };
}
